import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function QpInterface() {
  const [name, setName] = useState('');
  const [year, setYear] = useState();
  const [type, setType] = useState('');

  const navigate = useNavigate();

  function handleSubmit() {
    console.log(typeof year);
    if (!name || !year || !type) {
      toast.error("Invalid Entries");
      return;
    }

    axios.post('/qp', {
      name: name,
      year: Number(year),
      type: type
    }).then(res => {
      navigate('/');
    }).catch(err => {
      toast.error("Request failed, Internal Server Error");
    });
  }
  return (
    <>
    <ToastContainer />
      <div className="text-left">
        <div className="w-full max-w-sm mx-auto pt-[20vh]">
          <div>
            <p className="text-lg text-gray-600 font-bold p-4 text-center">
              Create Quiz Interface
            </p>
          </div>
          <div className="mb-6 ">
            <div className="">
              <label
                className="mb-1 block pr-4 font-bold text-gray-500"
                for="inline-full-name"
              >
                {" "}
                Name{" "}
              </label>
            </div>
            <div className="">
              <input
                className="w-full appearance-none rounded border-2 border-gray-200 bg-gray-100 py-2 px-4 leading-tight text-gray-700 focus:border-purple-500 focus:bg-white focus:outline-none"
                id="inline-full-name"
                type="text"
                value={name}
                onChange={(e)=>{setName(e.target.value)}}
                placeholder="JEE_MAINS_2022_D1_S1"
              />
            </div>
          </div>

          <div className="mb-6 ">
            <div>
              <label
                className="mb-1 block pr-4 font-bold text-gray-500"
                for="inline-full-name"
              >
                {" "}
                Year{" "}
              </label>
            </div>
            <div className="">
              <input
                className="w-full appearance-none rounded border-2 border-gray-200 bg-gray-100 py-2 px-4 leading-tight text-gray-700 focus:border-purple-500 focus:bg-white focus:outline-none"
                id="inline-full-name"
                type="number"
                value={year}
                onChange={(e)=>{setYear(e.target.value)}}
                placeholder='2022'
              />
            </div>
          </div>

          <div className="mb-6">
            <div className="">
              <label
                className="mb-1 block pr-4 font-bold text-gray-500"
                for="inline-full-name"
              >
                {" "}
                Type{" "}
              </label>
            </div>
            <select
              id="small"
              value={type}
              onChange={(e)=>{setType(e.target.value)}}
              className="mb-6 block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
            >
              <option selected>Choose type</option>
              <option value="NEET">NEET</option>
              <option value="AIIMS">AIIMS</option>
              <option value="JEE-Mains">JEE-Mains</option>
              <option value="JEE-Advanced">JEE-Advanced</option>
              <option value="Others">Others</option>
            </select>
          </div>

          <div>
            <div className=""></div>
            <div className="">
              <button
                onClick={handleSubmit}
                className="focus:shadow-outline rounded bg-purple-500 py-2 px-4 font-bold text-white shadow hover:bg-purple-400 focus:outline-none"
                type="button"
              >
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default QpInterface;
